<div class="n-vinculos-content">
  <div class="n-secao-vinculos">
    <div class="n-secao-header">
      <div class="n-header-left">
        <div class="n-header-icon-box">
          <i class="pi pi-users"></i>
        </div>
        <div class="n-secao-header-titles">
          <h4>{{ 'BARDO_CLIENTES.VINCULOS.TITULO' | translate }}</h4>
          <p>
            {{ 'BARDO_CLIENTES.VINCULOS.DESCRICAO' | translate: { nome: (getPrimeiroNome(cliente.nome) || cliente.nome) } }}
          </p>
        </div>
      </div>
    </div>


    @if ($carregandoVinculos()) {
    <div class="n-loading-vinculos">
      <i class="pi pi-spin pi-spinner mr-2 text-primary"></i> {{ 'BARDO_CLIENTES.VINCULOS.CARREGANDO' | translate }}
    </div>
    } @else {
    <!-- Subseção: Clientes Dependentes -->
    <div class="n-subsecao-vinculos">
      <div class="n-subsecao-header">
        <h5 class="n-subsecao-titulo">
          <i class="pi pi-user mr-2"></i>
          {{ 'BARDO_CLIENTES.VINCULOS.CLIENTES_QUE_AGENDA' | translate: { nome: (getPrimeiroNome(cliente.nome) || ('BARDO_CLIENTES.VINCULOS.ESTE_CLIENTE' | translate)) } }}
        </h5>
        <span class="n-badge-count" [class.active]="$dependentes().length > 0">
          {{ $dependentes().length }}
        </span>
      </div>

      @if ($dependentes().length > 0) {
      <div class="n-vinculos-lista">
        @for (vinculo of $dependentes(); track vinculo.id) {
        <div class="n-vinculo-item">
          <div class="n-vinculo-info">
            <div
              class="n-vinculo-avatar"
              [style.background-color]="getAvatarColor(vinculo.cliente?.id)"
            >
              {{ getIniciais(vinculo.cliente?.nome) }}
            </div>
            <div class="n-vinculo-dados">
              <span class="n-vinculo-nome">{{ vinculo.cliente?.nome }}</span>
              <span class="n-vinculo-detalhe">
                @if (vinculo.cliente?.telefone) {
                <i class="pi pi-phone"></i>
                {{ formatarTelefone(vinculo.cliente?.telefone) }}
                } @else {
                <span class="badge-sem-telefone"
                  >{{ 'BARDO_CLIENTES.VINCULOS.NOTIFICACAO_VIA_RESPONSAVEL' | translate }}</span
                >
                }
              </span>
            </div>
          </div>
          @if (possuiPermissao('Bardo.cliente.delete')) {
          <p-button
            icon="pi pi-trash"
            severity="danger"
            [text]="true"
            [rounded]="true"
            [pTooltip]="'BARDO_CLIENTES.VINCULOS.REMOVER_VINCULO' | translate"
            tooltipPosition="top"
            (onClick)="
              confirmarRemocaoVinculo(
                vinculo,
                vinculo.cliente?.nome || '',
                $event
              )
            "
          />
          }
        </div>
        }
      </div>
      } @else {
      <div class="n-empty-card">
        <i class="pi pi-exclamation-circle text-gray-400"></i>
        <span class="n-empty-text">{{ 'BARDO_CLIENTES.VINCULOS.NENHUM_DEPENDENTE_VINCULADO' | translate }}</span>
      </div>
      }
    </div>

    <!-- Subseção: Responsáveis -->
    <div class="n-subsecao-vinculos mt-3">
      <div class="n-subsecao-header">
        <h5 class="n-subsecao-titulo">
          <i class="pi pi-shield mr-2"></i>
          {{ 'BARDO_CLIENTES.VINCULOS.QUEM_AGENDA_POR' | translate: { nome: (getPrimeiroNome(cliente.nome) || ('BARDO_CLIENTES.VINCULOS.ESTE_CLIENTE' | translate)) } }}
        </h5>
        <span class="n-badge-count" [class.active]="$responsaveis().length > 0">
          {{ $responsaveis().length }}
        </span>
      </div>

      @if ($responsaveis().length > 0) {
      <div class="n-vinculos-lista">
        @for (vinculo of $responsaveis(); track vinculo.id) {
        <div class="n-vinculo-item">
          <div class="n-vinculo-info">
            <div
              class="n-vinculo-avatar"
              [style.background-color]="getAvatarColor(vinculo.responsavel?.id)"
            >
              {{ getIniciais(vinculo.responsavel?.nome) }}
            </div>
            <div class="n-vinculo-dados">
              <span class="n-vinculo-nome">{{
                vinculo.responsavel?.nome
              }}</span>
              <span class="n-vinculo-detalhe">
                @if (vinculo.responsavel?.telefone) {
                <i class="pi pi-phone"></i>
                {{ formatarTelefone(vinculo.responsavel?.telefone) }}
                } @else {
                <span class="badge-sem-telefone">{{ 'BARDO_CLIENTES.VINCULOS.RESPONSAVEL_REGISTRADO' | translate }}</span>
                }
              </span>
            </div>
          </div>
          @if (possuiPermissao('Bardo.cliente.delete')) {
          <p-button
            icon="pi pi-trash"
            severity="danger"
            [text]="true"
            [rounded]="true"
            [pTooltip]="'BARDO_CLIENTES.VINCULOS.REMOVER_VINCULO' | translate"
            tooltipPosition="top"
            (onClick)="
              confirmarRemocaoVinculo(
                vinculo,
                vinculo.responsavel?.nome || '',
                $event
              )
            "
          />
          }
        </div>
        }
      </div>
      } @else {
      <div class="n-empty-card">
        <i class="pi pi-exclamation-circle text-gray-400"></i>
        <span class="n-empty-text">{{ 'BARDO_CLIENTES.VINCULOS.NENHUM_RESPONSAVEL_VINCULADO' | translate }}</span>
      </div>
      }
    </div>
    }

    <!-- Botão de Ação no Rodapé para Adicionar Novo Vínculo -->
    @if (possuiPermissao('Bardo.cliente.create')) {
      <div class="n-footer-action mt-3 pt-2 border-top-1 border-100">
        <button
          type="button"
          class="n-btn-add-vinculo-blue w-full py-3 px-4 font-bold text-sm cursor-pointer flex align-items-center justify-content-center gap-2"
          (click)="abrirModalAdicionarVinculo()"
        >
          <i class="pi pi-plus text-xs"></i>
          <span>{{ 'BARDO_CLIENTES.VINCULOS.ADICIONAR_NOVO_VINCULO' | translate }}</span>
        </button>
      </div>
    }

  </div>
</div>


<!-- Templates do Modal -->
<!-- Templates do Modal -->
<ng-template #headerVinculoTemplate>
  <div class="flex align-items-center justify-content-between w-full">
    <h3 class="m-0 font-semibold text-lg text-900">
      {{ 'BARDO_CLIENTES.VINCULOS.ADICIONAR_VINCULO_MODAL' | translate }}
    </h3>
  </div>
</ng-template>

<ng-template #conteudoVinculoTemplate>
  <div class="flex flex-column gap-3 py-2">
    <!-- Tipo de Relacionamento -->
    <div class="flex flex-column gap-2">
      <span class="n-label-secao">{{ 'BARDO_CLIENTES.VINCULOS.TIPO_RELACIONAMENTO' | translate | uppercase }}</span>

      <div class="flex flex-column gap-2">
        <!-- Opção 1: Este cliente agendará por outro -->
        <label
          class="n-opcao-vinculo"
          [class.disabled]="!clientePossuiTelefone"
          [class.selected]="tipoVinculo() === 'dependente'"
        >
          <input
            type="radio"
            name="tipoVinculo"
            value="dependente"
            [disabled]="!clientePossuiTelefone"
            [ngModel]="tipoVinculo()"
            (ngModelChange)="onTipoVinculoChange($event)"
          />
          <div class="flex flex-column gap-1 w-full">
            <div class="flex align-items-center gap-2">
              <i class="pi pi-user text-base"></i>
              <span class="font-semibold text-sm n-opcao-titulo">
                {{ 'BARDO_CLIENTES.VINCULOS.ESTE_AGENDARA_POR_OUTRO' | translate }}
              </span>
            </div>
            <span class="text-xs n-opcao-subtitulo">
              {{ 'BARDO_CLIENTES.VINCULOS.ESTE_AGENDARA_SUBTITULO' | translate:{ nome: getPrimeiroNome(cliente.nome) || cliente.nome } }}
            </span>
            @if (!clientePossuiTelefone) {
            <div class="n-alert-box-warning mt-2">
              <i class="pi pi-exclamation-triangle"></i>
              <span>
                {{ 'BARDO_CLIENTES.VINCULOS.ALERTA_TELEFONE_NECESSARIO' | translate }}
              </span>
            </div>
            }
          </div>
        </label>

        <!-- Opção 2: Outro cliente agendará por este -->
        <label
          class="n-opcao-vinculo"
          [class.selected]="tipoVinculo() === 'responsavel'"
        >
          <input
            type="radio"
            name="tipoVinculo"
            value="responsavel"
            [ngModel]="tipoVinculo()"
            (ngModelChange)="onTipoVinculoChange($event)"
          />
          <div class="flex flex-column gap-1 w-full">
            <div class="flex align-items-center gap-2">
              <i class="pi pi-user-plus text-base"></i>
              <span class="font-semibold text-sm n-opcao-titulo">
                {{ 'BARDO_CLIENTES.VINCULOS.OUTRO_AGENDARA_POR_ESTE' | translate }}
              </span>
            </div>
            <span class="text-xs n-opcao-subtitulo">
              {{ 'BARDO_CLIENTES.VINCULOS.OUTRO_AGENDARA_SUBTITULO' | translate:{ nome: getPrimeiroNome(cliente.nome) || cliente.nome } }}
            </span>
          </div>
        </label>
      </div>
    </div>

    <!-- Seleção de Cliente / Responsável -->
    <div class="flex flex-column gap-2 mt-2">
      <span class="font-semibold text-sm text-800">
        @if (tipoVinculo() === 'dependente') {
          {{ 'BARDO_CLIENTES.VINCULOS.SELECIONE_DEPENDENTE' | translate }}
        } @else {
          {{ 'BARDO_CLIENTES.VINCULOS.SELECIONE_RESPONSAVEL' | translate }}
        }
      </span>

      @if (deviceService.$isMobile()) {
      <lib-n-multiselect
        [multiple]="false"
        [ngModel]="clienteSelecionadoParaVinculoId()"
        (ngModelChange)="clienteSelecionadoParaVinculoId.set($event)"
        [options]="opcoesOutrosClientes()"
        optionLabel="label"
        optionValue="value"
        [placeholder]="(tipoVinculo() === 'dependente' ? 'BARDO_CLIENTES.VINCULOS.PLACEHOLDER_DEPENDENTE' : 'BARDO_CLIENTES.VINCULOS.PLACEHOLDER_RESPONSAVEL') | translate"
      />
      } @else {
      <p-select
        [options]="opcoesOutrosClientes()"
        [ngModel]="clienteSelecionadoParaVinculoId()"
        (ngModelChange)="clienteSelecionadoParaVinculoId.set($event)"
        optionLabel="label"
        optionValue="value"
        [placeholder]="(tipoVinculo() === 'dependente' ? 'BARDO_CLIENTES.VINCULOS.PLACEHOLDER_DEPENDENTE' : 'BARDO_CLIENTES.VINCULOS.PLACEHOLDER_RESPONSAVEL') | translate"
        [filter]="true"
        filterBy="label"
        appendTo="body"
        [filterPlaceholder]="'BARDO_CLIENTES.VINCULOS.BUSCAR_CLIENTE_NOME' | translate"
        styleClass="w-full"
        [loading]="carregandoClientesParaVinculo()"
      />
      }
    </div>

    <!-- Botões de Ação Salvar Vínculo e Cancelar -->
    <div class="flex justify-content-end gap-2 pt-3 mt-3 border-top-1 border-100 w-full">
      <p-button
        [label]="'GLOBAL.CANCELAR' | translate"
        severity="secondary"
        [outlined]="true"
        styleClass="w-full sm:w-auto"
        (onClick)="fecharModalVinculo()"
      />
      <p-button
        [label]="'BARDO_CLIENTES.VINCULOS.SALVAR_VINCULO' | translate"
        icon="pi pi-check"
        severity="primary"
        styleClass="w-full sm:w-auto"
        [loading]="salvandoVinculo()"
        [disabled]="!clienteSelecionadoParaVinculoId()"
        (onClick)="salvarVinculo()"
      />
    </div>
  </div>
</ng-template>

<ng-template #footerVinculoTemplate>
  <div class="flex justify-content-end gap-2 pt-2 w-full">
    <p-button
      [label]="'GLOBAL.CANCELAR' | translate"
      severity="secondary"
      [outlined]="true"
      styleClass="w-full sm:w-auto"
      (onClick)="fecharModalVinculo()"
    />
    <p-button
      [label]="'BARDO_CLIENTES.VINCULOS.SALVAR_VINCULO' | translate"
      icon="pi pi-check"
      severity="primary"
      styleClass="w-full sm:w-auto"
      [loading]="salvandoVinculo()"
      [disabled]="!clienteSelecionadoParaVinculoId()"
      (onClick)="salvarVinculo()"
    />
  </div>
</ng-template>


<!-- Mobile: Bottom Sheet -->
@if (deviceService.$isMobile() && modalVinculoAberto()) {
<lib-bottom-sheet
  [visible]="modalVinculoAberto()"
  (visibleChange)="modalVinculoAberto.set($event)"
  size="full"
  [draggable]="true"
  [closeOnBackdrop]="!salvandoVinculo()"
  [closeOnEscape]="!salvandoVinculo()"
  [preventClose]="salvandoVinculo()"
  [headerTemplate]="headerVinculoTemplate"
  [footerTemplate]="footerVinculoTemplate"
  (hide)="fecharModalVinculo()"
>
  <ng-container *ngTemplateOutlet="conteudoVinculoTemplate"></ng-container>
</lib-bottom-sheet>
} @else {
<!-- Desktop: Dialog -->
<p-dialog
  [header]="'BARDO_CLIENTES.VINCULOS.ADICIONAR_VINCULO_MODAL' | translate"
  [visible]="modalVinculoAberto()"
  (visibleChange)="modalVinculoAberto.set($event)"
  [modal]="true"
  [style]="{ width: '480px' }"
  [draggable]="false"
  [resizable]="false"
>
  <ng-container *ngTemplateOutlet="conteudoVinculoTemplate"></ng-container>

  <ng-template pTemplate="footer">
    <ng-container *ngTemplateOutlet="footerVinculoTemplate"></ng-container>
  </ng-template>
</p-dialog>
}

<!-- Mobile Bottom Sheet para Confirmar Remoção de Vínculo -->
@if (deviceService.$isMobile() && modalConfirmacaoRemocaoAberto()) {
<lib-bottom-sheet
  [visible]="modalConfirmacaoRemocaoAberto()"
  (visibleChange)="modalConfirmacaoRemocaoAberto.set($event)"
  size="medium"
  [draggable]="true"
  [closeOnBackdrop]="!removendoVinculo()"
  [closeOnEscape]="!removendoVinculo()"
  [preventClose]="removendoVinculo()"
  [headerTemplate]="headerRemoverVinculoTemplate"
  [footerTemplate]="footerRemoverVinculoTemplate"
  (hide)="modalConfirmacaoRemocaoAberto.set(false)"
>
  <div class="flex flex-column align-items-center text-center py-3 px-2 gap-3">
    <div
      class="w-3rem h-3rem border-circle bg-red-100 flex align-items-center justify-content-center"
    >
      <i class="pi pi-exclamation-triangle text-red-600 text-2xl"></i>
    </div>
    <p
      class="m-0 text-700 text-base line-height-3"
      [innerHTML]="'BARDO_CLIENTES.VINCULOS.CONFIRMAR_REMOCAO_MSG' | translate:{ nome: vinculoParaRemover()?.nome }"
    ></p>
  </div>
</lib-bottom-sheet>
}

<ng-template #headerRemoverVinculoTemplate>
  <div class="flex align-items-center justify-content-between w-full">
    <h3 class="m-0 font-semibold text-lg">
      {{ 'BARDO_CLIENTES.VINCULOS.CONFIRMAR_REMOCAO_TITULO' | translate }}
    </h3>
  </div>
</ng-template>

<ng-template #footerRemoverVinculoTemplate>
  <div class="flex gap-2 w-full pt-2">
    <p-button
      [label]="'GLOBAL.CANCELAR' | translate"
      severity="secondary"
      [outlined]="true"
      styleClass="w-full"
      (onClick)="modalConfirmacaoRemocaoAberto.set(false)"
      [disabled]="removendoVinculo()"
    />
    <p-button
      [label]="'GLOBAL.SIM_REMOVER' | translate"
      severity="danger"
      styleClass="w-full"
      icon="pi pi-trash"
      [loading]="removendoVinculo()"
      (onClick)="confirmarRemocaoConfirmadaMobile()"
    />
  </div>
</ng-template>
